import React, { createContext, useState, useContext, useEffect } from 'react';

const initDays = require('./sample/empty.json');

const Context = createContext();

export const useGlobalContext = () => useContext(Context);

export const GlobalProvider = ({ children }) => {
  const [messages, setMessages] = useState([
    {
      role: 'bot',
      content: 'What kind of holiday are you interested in?',
    },
  ]);
  const [days, setDays] = useState(initDays);
  const [selectedDay, setSelectedDay] = useState('1');
  const [activeElement, setActiveElement] = useState(null);
  const [token, setToken] = useState(null);

  useEffect(() => {
    const events = days[selectedDay]?.events;
    if (!!events && events.length > 0) {
      setActiveElement({ type: 'event', id: events[0]?.id });
    } else {
      setSelectedDay('1');
    }
  }, [selectedDay, days]);

  useEffect(() => {
    const storedToken = localStorage.getItem('token');
    if (storedToken) {
      setToken(storedToken);
    }
  }, []);

  return (
    <Context.Provider
      value={{
        messages,
        setMessages,
        selectedDay,
        setSelectedDay,
        days,
        setDays,
        activeElement,
        setActiveElement,
        token,
        setToken,
      }}
    >
      {children}
    </Context.Provider>
  );
};
